import api from './api';

export const getAllExams = async () => {
    try {
        const response = await api.get('/exams');
        return response.data;
    } catch (error) {
        console.error("Error fetching exams:", error);
        throw error;
    }
};

// --- MODIFIED FUNCTION ---
export const createExam = async (examData) => {
    // Now sends the full object instead of just a name
    const response = await api.post('/exams', examData);
    return response.data;
};

// --- MODIFIED FUNCTION ---
export const updateExam = async (id, examData) => {
    // Now sends the full object
    const response = await api.put(`/exams/${id}`, examData);
    return response.data;
};

export const deleteExam = async (id) => {
    await api.delete(`/exams/${id}`);
};

export const getExamSubjects = async (examId) => {
    const response = await api.get(`/exams/${examId}/subjects`);
    return response.data;
};
